"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidTag = void 0;
var invalidTagValueType = ['number', 'string', 'boolean'];
var TAG_KEY_LENGTH_LIMIT = 32;
var TAG_VALUE_LENGTH_LIMIT = 250;
function isValidTag(key, value) {
    if (!invalidTagValueType.includes(typeof value)) {
        return false;
    }
    if (key.length > TAG_KEY_LENGTH_LIMIT) {
        return false;
    }
    if (typeof value === 'string' && value.length > TAG_VALUE_LENGTH_LIMIT) {
        return false;
    }
    return true;
}
exports.isValidTag = isValidTag;
